<template>
  <MSButton class="play-now-btn" :type="'play'" @click="playFreeNow">Play Now</MSButton>
</template>
<script setup lang="ts">
const playFreeNow = () => {
  window.nexon.play()
}
</script>
